import React, { useEffect, useRef } from 'react'

function AppAudio(props) {
  const { audioStateHandler, audioLength, audio, status } = props
  const audio23 = useRef()

  useEffect(() => {
    var audio = document.getElementById('audio1')
    audio.play()
    //audioStateHandler();
  },[audio])

  return (
    <div>
      <audio
        id="audio1"
        ref={audio23}
        //onEnded={audioStateHandler}
        src={audio}
        autoPlay={true}
        type="audio/mp4"
        />
    </div>
  )
}

export default React.memo(AppAudio)
